const restoreSubscription = () => {
  let subscription = null;

  try {
    const storedData = localStorage.getItem('subscription');

    if (storedData) {
      subscription = JSON.parse(storedData);
    }
  } catch {
    subscription = null;
  }

  return subscription;
};

const storeSubscription = (subscription) => {
  localStorage.setItem('subscription', JSON.stringify(subscription));
};

export { restoreSubscription, storeSubscription };
